module.exports = __webpack_public_path__ + "img/banner.f90b1c3d.png";